import { persistStore,persistReducer } from "redux-persist"; 
import allReducers from './reducers'
import storage  from "redux-persist/lib/storage";
import { createStore } from 'redux'
import { encryptTransform } from 'redux-persist-transform-encrypt';

const persistConfig = {
    key: 'erp-key',
    transforms: [
        encryptTransform({
            secretKey: 'persist-key',
            onError: function (error) {
                console.log(error)
            },
        }),
    ],
    storage,
}
const persistedReducer = persistReducer(persistConfig, allReducers)

const store = createStore(persistedReducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const persistore = persistStore(store)

export default store

export {persistore}